(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trading-dashboard', {
            parent: 'entity',
            url: '/trading-dashboard',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.dashboard.trading" | translate }}',
                parent: 'entity'
            },
            views: {
                'content@': {
                    templateUrl: 'app/dashboard/3/dashboard.html',
                    controller: 'TradingPageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('error');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
